// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"b95d291f","243":"1495653b","293":"1ecf9b43","295":"9b5d6432","435":"ca62d96f","453":"94109cef","572":"8a41455e","615":"1d23f7b1","665":"353a6d36","815":"8f0c79ec","942":"b23c9949","997":"8f016bc6"}[chunkId] + ".chunk.js";
};